export const ButtonBannerMock1 = {
  buttonMultifield: [
    {
      ctaType: 'secondaryButton',
      altText: '',
      leadingIcon: 'Brands',
      fileReferenceImage: '',
      linkUrl: '#link',
      trailingIcon: false,
      linkText: 'Explore More',
      linkType: 'external',
      clickTrackValue: 'Button Banner|Explore More|external',
      linkPathType: 'link',
    },
    {
      ctaType: 'primaryButton',
      altText: 'testing pdt for update and efforts',
      leadingIcon: '',
      fileReferenceImage:
        '/content/dam/marriott-digital/rz/journey/en_us/photo/unlimited/assets/rz-from-arrays-to-ngs-how-ch-44465.jpg',
      linkUrl: '',
      trailingIcon: true,
      linkText: 'Floor Plan',
      linkType: 'external',
      clickTrackValue: 'Button Banner|Floor Plan|external',
      linkPathType: 'image',
    },
  ],
  path: '/content/mi-luxury-spa/language-masters/na/en-us/destinations/jcr:content/root/responsivegrid/button_banner_314938868',
  componentId: 'ixubooaqrawh29s6',
  enableTracking: true,
  ':type': 'mi-aem-luxury-spa/components/content/button-banner/v1/button-banner',
  buttonSize: 'large',
  wcmMode: 'edit',
  isAuthor: true,
};
export const ButtonBannerMock2 = {
  buttonMultifield: [
    {
      ctaType: 'textLink',
      altText: '',
      leadingIcon: 'Brands',
      fileReferenceImage: '',
      linkUrl: '#link',
      trailingIcon: false,
      linkText: 'Explore More',
      linkType: 'external',
      clickTrackValue: 'Button Banner|Explore More|external',
      linkPathType: 'link',
    },
    {
      ctaType: 'tertiaryLink',
      altText: 'testing pdt for update and efforts',
      leadingIcon: '',
      fileReferenceImage:
        '/content/dam/marriott-digital/rz/journey/en_us/photo/unlimited/assets/rz-from-arrays-to-ngs-how-ch-44465.jpg',
      linkUrl: '',
      trailingIcon: true,
      linkText: 'Floor Plan',
      linkType: 'external',
      clickTrackValue: 'Button Banner|Floor Plan|external',
      linkPathType: 'image',
    },
    {
      ctaType: 'tertiaryLink',
      altText: 'testing pdt for update and efforts',
      leadingIcon: '',
      // fileReferenceImage:
      //   '/content/dam/marriott-digital/rz/journey/en_us/photo/unlimited/assets/rz-from-arrays-to-ngs-how-ch-44465.jpg',
      linkUrl: '',
      trailingIcon: true,
      linkText: 'Floor Plan',
      linkType: 'external',
      clickTrackValue: 'Button Banner|Floor Plan|external',
      linkPathType: 'image',
      openInANewTab: false,
    },
    {
      ctaType: 'primaryButton',
      altText: 'testing pdt for update and efforts',
      leadingIcon: 'Brands',
      linkUrl: '',
      trailingIcon: true,
      linkText: 'Floor Plan',
      linkType: 'external',
      clickTrackValue: 'Button Banner|Floor Plan|external',
      linkPathType: 'image',
      openInANewTab: false,
    },
  ],
  path: '/content/mi-luxury-spa/language-masters/na/en-us/destinations/jcr:content/root/responsivegrid/button_banner_314938868',
  componentId: 'ixubooaqrawh29s6',
  enableTracking: true,
  ':type': 'mi-aem-luxury-spa/components/content/button-banner/v1/button-banner',
  buttonSize: 'large',
  wcmMode: 'edit',
  isAuthor: true,
};
